import React from "react";
import { Box, Divider } from "@mui/material";
import { useParams } from "react-router-dom";
import { WizardStepProps } from "@components/WizardCst/types";
import { ActivityWizardData } from "../../types";
import { MAIN_INFO_BY_TYPE } from "./config/mainInfoTypeConfig";
import BasicFieldsSection from "./sections/BasicFieldsSection";
import ContentSection from "./sections/ContentSection";
import CoverSection from "./sections/CoverSection";
import StandaloneSection from "./sections/StandaloneSection";
import PublicationSection from "./sections/PublicationSection";
import MobileFruitionSection from "./sections/MobileFruitionSection";
import UsageLimitsSection from "./sections/UsageLimitsSection";
import VersioningSection from "./sections/VersioningSection";
import AgendaSection from "./sections/AgendaSection";

const SectionDivider: React.FC = () => <Divider sx={{ opacity: 0.6 }} />;

interface MainInfoStepProps extends WizardStepProps<ActivityWizardData> {
  lockPublication?: boolean;
}

const MainInfoStep: React.FC<MainInfoStepProps> = ({
  data,
  setData,
  errors,
  lockPublication = false,
}) => {
  const { id: corporateId = "" } = useParams();
  if (!data.type) return null;
  const config = MAIN_INFO_BY_TYPE[data.type];
  const sections = config.sections;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      {sections.includes("basic") && (
        <BasicFieldsSection
          data={data}
          setData={setData}
          errors={errors}
          durationRequired={config.durationRequired}
          showMinCompletion={config.contentVariant === "class"}
        />
      )}

      {sections.includes("content") && (
        <>
          <SectionDivider />
          <ContentSection
            variant={config.contentVariant}
            data={data}
            setData={setData}
            errors={errors}
            locked={lockPublication}
          />
        </>
      )}

      {sections.includes("cover") && (
        <>
          <SectionDivider />
          <CoverSection data={data} setData={setData} errors={errors} />
        </>
      )}

      {sections.includes("standalone") && (
        <>
          <SectionDivider />
          <StandaloneSection
            data={data}
            setData={setData}
            errors={errors}
            locked={lockPublication}
          />
        </>
      )}

      {sections.includes("publication") && data.is_standalone && (
        <>
          <SectionDivider />
          <PublicationSection
            data={data}
            setData={setData}
            errors={errors}
            locked={lockPublication}
          />
        </>
      )}

      {sections.includes("mobile") && (
        <>
          <SectionDivider />
          <MobileFruitionSection
            data={data}
            setData={setData}
            errors={errors}
          />
        </>
      )}

      {sections.includes("limits") &&
        data.is_standalone &&
        corporateId !== "1" && (
          <>
            <SectionDivider />
            <UsageLimitsSection data={data} setData={setData} errors={errors} />
          </>
        )}

      {sections.includes("versioning") && (
        <>
          <SectionDivider />
          <VersioningSection data={data} setData={setData} errors={errors} />
        </>
      )}

      {sections.includes("agenda") && (
        <>
          <SectionDivider />
          <AgendaSection data={data} setData={setData} errors={errors} />
        </>
      )}
    </Box>
  );
};

export default MainInfoStep;
